import { useCallback } from "react";
import {
  type ParamsOverride,
  usePathHandler,
} from "src/shared/hooks/usePathHandler";
import {
  CREATE_STORE_VIEW_PATH,
  EDIT_STORE_VIEW_PATH,
  STORES_VIEW_PATH,
  STORE_DETAIL_VIEW_PATH,
} from "src/stores/views/StorePaths";

export const useStoresViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    (params?: ParamsOverride) => pathHandler(STORES_VIEW_PATH, params),
    [pathHandler],
  );
};

export const useStoreCreateViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(() => pathHandler(CREATE_STORE_VIEW_PATH), [pathHandler]);
};

export const useStoreDetailViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    (storeUuid: string, paramsOverride?: ParamsOverride) =>
      pathHandler(
        STORE_DETAIL_VIEW_PATH.replace(":storeUUID", storeUuid),
        paramsOverride,
      ),
    [pathHandler],
  );
};

export const useStoreEditViewPathHandler = () => {
  const pathHandler = usePathHandler();
  return useCallback(
    (storeUuid: string, paramsOverride?: ParamsOverride) =>
      pathHandler(
        EDIT_STORE_VIEW_PATH.replace(":storeUUID", storeUuid),
        paramsOverride,
      ),
    [pathHandler],
  );
};
